<template>

    <div class="vx-row">
        <div class="vx-col w-2/3">
            <vs-card>
                <vs-input v-model="name" class="w-full" placeholder="Naam"></vs-input>
            </vs-card>
            <vs-card class="mb-4">
                <div slot="header">
                    <h5>Beschrijving</h5>
                </div>
                <div>
                    <vs-textarea v-model="description" height="250px"></vs-textarea>
                </div>
            </vs-card>
        </div>
        <div class="vx-col w-1/3">
            <vs-button @click="createCategory" class="w-full mb-6">Opslaan</vs-button>
            <vs-card class="mb-4">
                <div>
                    <vs-input v-model="position" class="w-full mb-4" placeholder="Positie"></vs-input>
                </div>
            </vs-card>
            <vs-card>
                <div slot="header">
                    <h5>Afbeelding</h5>
                </div>
                <div>
                    <vs-upload @change="handleImageUpload" @on-delete="image = null" />
                </div>
            </vs-card>
        </div>
    </div>

</template>

<script>
export default {
    data() {
        return {
            position: '',
            name: '',
            description: '',
            image: null
        }
    },
    created() {},
    computed: {
        imageUrl: function() {
            if(this.image != null) {
                return URL.createObjectURL(this.image);
            }
        },
        staffRoute () {
            if(this.$route.meta.staff) {
                if(localStorage.getItem('stafftoken') !== null) {
                    return true
                }
            } else {
                if(localStorage.getItem('stafftoken') !== null) {
                    return true
                }
                return false
            }
        },
    },
    methods: {
        handleImageUpload: function(e, f) {
            this.image = f[0];
        },
        createCategory: function() {
            let formData = new FormData();

            formData.append('name', this.name);
            formData.append('description', this.description);
            formData.append('position', this.position);
            formData.append('image', this.image);

            let token = this.staffRoute ? JSON.parse(localStorage.getItem('stafftoken')) : JSON.parse(localStorage.getItem('companytoken'));
            let url = this.staffRoute ? 'https://staffapi.hebtrek.nl/v1/company/'+ this.$route.params.slug +'/product-category/create' : 'https://companyapi.hebtrek.nl/v1/company/'+ this.$route.params.slug +'/product-category/create'
            this.$http.post(url, formData,
            {
                headers: {
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then((response) => {
                console.log(response)
                this.$router.push({'name': 'companies-product-categories'});
                this.$vs.notify({
                    title: 'Success',
                    text: 'Succesvol opgeslagen',
                    color: 'success'
                });
            }).catch((error) => {
                this.$util.logError(error, this.$vs);
            })
        }
    }
}
</script>

<style>

</style>
